export const GET_SETTINGS = 'SETTINGS/get_settings';
export const GET_SINGLE_SETTING = 'SETTINGS/get_single_setting';
export const UPDATE_SETTING = 'SETTINGS/update_setting';
export const CREATE_SETTING = 'SETTINGS/create_setting';
export const REMOVE_SETTING = 'SETTINGS/remove_setting';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  photo: '',
  title: '',
  description: '',
  start_date: '',
  end_date: '',
};
